import { AvailabilityCalendarRequest, AvailabilityDate } from "@/modules/AvailabilityCalendar/models/AvailabilityDate";
import { AvailabilityDateResponse } from "@/modules/AvailabilityCalendar/models/AvailabilityDateResponse";
import { ref } from "vue";
import useApi from "../../../composables/useApi";

const useCalendarQuery = () => {
    const { post } = useApi();

    const apiSearch = ref<AvailabilityCalendarRequest>({
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
        route: undefined,
        cabin: undefined,
        vehicle: undefined,
    });

    const dates = ref<AvailabilityDate[] | undefined>(undefined);

    const isLoading = ref(false);

    const getDates = () => {
        isLoading.value = true;

        return post<AvailabilityDateResponse>("/availability/dates", apiSearch.value)
            .then((resp) => {
                dates.value = resp.data?.dates.map((d) => new AvailabilityDate(d)) ?? [];
            })
            .catch((err) => {
                return Promise.reject(err);
            })
            .finally(() => {
                isLoading.value = false;
            });
    };

    const updateParams = (params: AvailabilityCalendarRequest) => {
        apiSearch.value = params;

        const hasAllParams = (!!params.cabin || !!params.vehicle) && !!params.route && !!params.month && !!params.year;

        if (hasAllParams) {
            getDates();
        }
    };

    return {
        params: apiSearch,
        updateParams,
        dates,
        isLoading,
    };
};

export default useCalendarQuery;
